import { useState, useEffect } from "react";
import { FaMinus, FaPlus } from "react-icons/fa";
import { MenuPermissionAPI } from "../../../utlis/apiService";
import InputField from "../../../common/InputField";
import { FormFooter } from "../../../common/Shared";
import Model from "../../../common/Model";

const MenuPermissionForm = ({
  isUserData,
  isMenuIDSData,
  onCancel,
  isEditing,
  onSubmit,
  formData,
}) => {
  const [userId, setUserId] = useState(null);
  const [permissions, setPermissions] = useState([
    { menuId: null, insert: false, update: false, delete: false, view: false },
  ]);
  const [localFormData, setLocalFormData] = useState({
    userId: "",
    menuId: [],
  });

  useEffect(() => {
    if (formData?.userId) {
      setUserId(formData.userId);
      setLocalFormData((prev) => ({
        ...prev,
        userId: formData.userId,
      }));
      setPermissions(
        formData.permissions?.length
          ? formData.permissions
          : [
              {
                menuId: null,
                insert: false,
                update: false,
                delete: false,
                view: false,
              },
            ],
      );
    }
  }, [formData]);

  const handleChange = (index, field, value) => {
    const updated = [...permissions];
    updated[index][field] = value;
    setPermissions(updated);
  };

  const handleAddRow = () => {
    setPermissions([
      ...permissions,
      {
        menuId: null,
        insert: false,
        update: false,
        delete: false,
        view: false,
      },
    ]);
  };

  const handleRemoveRow = (index) => {
    const item = permissions[index];
    if (userId && item.menuId) {
      MenuPermissionAPI.deleteMenuId(userId, item.menuId).then(() => {
        const updated = [...permissions];
        updated.splice(index, 1);
        setPermissions(updated);
      });
    } else {
      const updated = [...permissions];
      updated.splice(index, 1);
      setPermissions(updated);
    }
  };

  const handleSubmitPermissions = () => {
    const payload = permissions
      .filter((p) => p.menuId)
      .map((p) => ({
        UserId: Number(localFormData.userId),
        MenuId: Number(p.menuId),
        IsInsert: p.insert,
        IsUpdate: p.update,
        IsDelete: p.delete,
        IsView: p.view,
      }));
    onSubmit(payload);
  };

  return (
    <Model
      isOpen={true}
      onClose={onCancel}
      name={isEditing ? "Modify Menu Permissions" : "Set New Menu Permissions"}
      widthClass="max-w-5xl"
    >
      <div className="flex flex-col">
        {/* User Selector */}
        <div className="p-6 border-b border-slate-100">
          <InputField
            type="select"
            label="Target User / Operator"
            options={isUserData}
            value={localFormData.userId}
            onChange={(selectedValue) => {
              setLocalFormData((prev) => ({
                ...prev,
                userId: selectedValue,
              }));
            }}
            required
          />
        </div>

        {/* Permission Matrix */}
        <div className="border-b border-slate-100">
          <div className="bg-gray-50 px-6 py-3 border-b border-gray-100">
            <h4 className="text-[11px] font-black text-gray-500 uppercase tracking-[2px]">
              Permission Matrix
            </h4>
          </div>
          <div className="overflow-x-auto">
            <table className="w-full text-[13px] border-collapse">
              <thead className="bg-white">
                <tr className="text-left text-[10px] font-black text-gray-400 uppercase tracking-[2px] border-b border-gray-100">
                  <th className="px-6 py-3 border-r border-gray-100">Menu</th>
                  <th className="px-6 py-3 border-r border-gray-100 text-center">Insert</th>
                  <th className="px-6 py-3 border-r border-gray-100 text-center">Update</th>
                  <th className="px-6 py-3 border-r border-gray-100 text-center">Delete</th>
                  <th className="px-6 py-3 border-r border-gray-100 text-center">View</th>
                  <th className="px-6 py-3 text-center w-24">Action</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-50">
                {permissions.map((row, index) => (
                  <tr key={index} className="hover:bg-gray-50 transition-colors">
                    <td className="px-4 py-2 border-r border-gray-50 min-w-[250px]">
                      <InputField
                        type="select"
                        options={isMenuIDSData}
                        value={row.menuId}
                        onChange={(val) => handleChange(index, "menuId", val)}
                        placeholder="Select Menu"
                      />
                    </td>
                    {["insert", "update", "delete", "view"].map((perm) => (
                      <td
                        className="px-4 py-2 border-r border-gray-50 text-center"
                        key={perm}
                      >
                        <input
                          type="checkbox"
                          checked={row[perm]}
                          className="w-4 h-4 text-primary focus:ring-primary border-gray-300"
                          onChange={() =>
                            handleChange(index, perm, !row[perm])
                          }
                        />
                      </td>
                    ))}
                    <td className="px-4 py-2 text-center">
                      <div className="flex justify-center gap-1">
                        <button
                          onClick={() => handleRemoveRow(index)}
                          className="p-1.5 text-red-400 hover:text-red-600 hover:bg-red-50 border border-transparent hover:border-red-100 transition-all"
                          title="Remove Row"
                        >
                          <FaMinus size={12} />
                        </button>
                        <button
                          onClick={handleAddRow}
                          className="p-1.5 text-primary hover:bg-blue-50 border border-transparent hover:border-primary/20 transition-all"
                          title="Add Row"
                        >
                          <FaPlus size={12} />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <FormFooter
          onCancel={onCancel}
          onSubmit={handleSubmitPermissions}
          submitText={isEditing ? "Confirm Update" : "Commit Changes"}
        />
      </div>
    </Model>
  );
};

export default MenuPermissionForm;
